/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  dialog: {
    '& .MuiDialog-paper': {
      overflowY: 'visible'
    },
    '& .MuiDialogContent-root': {
      overflowY: 'scroll',
      minHeight: '500px',
    }
  },
  dialogWithoutScroll: {

  },
  listbox: {
    paddingTop: Tokens.spacing['$sp-2'],
    '& li:first-child': {
      borderTop: `1px solid ${theme.palette.background.paper}`
    },
    '& li:nth-child(2n)': {
      cursor: 'pointer'
    }
  },
  titleAlignment: {
    fontSize: Tokens.spacing['$sp-6'],
    marginBottom: Tokens.spacing['$sp-4'],
  },
  innerContent: {
    marginTop: '40%',
    textAlign: 'center'
  },
  containerHeight: {
    overflow: 'auto',
    height: Tokens.spacing['$sp-70'],
    marginTop: Tokens.spacing['$sp-2'],
  },
  customLoader: {
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'flex-start',
    padding: 0
  },
  groupItem : {
   flexDirection: 'column',
   alignItems: 'flex-start',
  },
  groupBy: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 500,
    fontSize: Tokens.spacing['$sp-3'],
    width : '100%',
    paddingTop: Tokens.spacing['$sp-2'],
  },
  optionDesc: {
    fontWeight: 400,
    fontSize: Tokens.spacing['$sp-4'],
    width : '100%',
    padding: `${Tokens.spacing['$sp-1']} 0 ${Tokens.spacing['$sp-2']}`,
  },
  wrap: {
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
  },
  searchIcon: {
    padding: 0,
    color: theme.palette.text.secondary,
    cursor: 'initial'
  },
  formControl: {
    marginBottom: Tokens.spacing['$sp-4']
  },
  displayRadioGroup: {
    display: 'flex',
    flexDirection: 'row'
  },
  textFieldSpacing: {
    marginBottom: Tokens.spacing['$sp-6']
  },
  dropDownFieldSpacing: {
    marginTop: Tokens.spacing['$sp-5']
  },
  fontTyphography: {
    fontSize: Tokens.spacing['$sp-3']
  },
  boxSpacing: {
    marginBottom: Tokens.spacing['$sp-7-5']
  },
  root: {
    '& .MuiDialog-paperWidthXs': {
      // maxWidth: theme.spacing(44.2)
    },
    '& .MuiDialogTitle-root': {
      height: Tokens.spacing['$sp-14'],
    }
  },
  dropDownBox: {
    marginTop: Tokens.spacing['$sp-2-5']
  },
  formStyle: {
    padding: `${Tokens.spacing['$sp-2']} 0 0`,
  },
  formStyleWithoutPadding: {
    padding: `${theme.spacing(1)} 0`,
  },
  blockOperator: {
    paddingTop: '9px'
  },
  optionItem: {
    display: 'block',
    height: '100%!important',
    paddingTop: Tokens.spacing['$sp-3'],
    paddingBottom: Tokens.spacing['$sp-3'],
    paddingLeft: Tokens.spacing['$sp-4'],
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  optionItemName: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: '20px'
  },
  optionItemDescription: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
    lineHeight: '16px'
  },
  dimensionDropdown: {
    marginTop: '7px',
  },
  hierarchyAccessScope: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  hierarchyTypographyTitle: {
    fontWeight: 500,
  },
  accessTypography: {
    fontWeight: 500,
    paddingTop: 0,
  },
  accessTypographyDescription: {
    paddingBottom: Tokens.spacing['$sp-2']
  },
  hierarchyAccessSwitch: {
    display: 'flex',
    alignItems: 'center'
  },
  formErrorStyle: {
    padding: Tokens.spacing['$sp-2'],
    paddingTop: Tokens.spacing['$sp-6']
  },
  formStyleAutoComplete: {

  },
  gridContainer: {
    paddingBottom: Tokens.spacing['$sp-4'],
    backgroundColor: theme.palette.background.paper,
  },
  attributeSection: {
    paddingTop: Tokens.spacing['$sp-4'],
  } ,
  attributeHeading: {
    marginRight: Tokens.spacing['$sp-4'],
    fontWeight: 500
  },
  deleteIcon: {
    cursor: 'pointer',
  },
  accordion: {
    border: `1px solid ${theme.palette.divider}`,
    borderBottom: 'none',
    '&:first-of-type': {
     borderBottom: 'none',
    },
    '&:last-of-type': {
     borderBottomLeftRadius: 0,
     borderBottomRightRadius: 0,
     borderTop: `1px solid ${theme.palette.divider} !important`,
     borderBottom: `1px solid ${theme.palette.divider} !important`,
    },
    '&::before': {
      display: 'none'
    },
    '&.Mui-disabled': {
      backgroundColor: theme.palette.background.paper,
    }
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column'
  },
  infoMsg: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: Tokens.spacing['$sp-3'],
    padding: Tokens.spacing['$sp-4'],
    borderRadius: Tokens.spacing['$sp-1-25'],
    color: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.secondary.main}`,
    fontSize: Tokens.spacing['$sp-3-5'],
  },
  infoIcon: {
    marginRight: 10,
    color: theme.palette.secondary.main,
  },
  alert: {
    marginTop: 14,
  },
  entityOptionItem: {
    color: theme.palette.text.primary,
    height: Tokens.spacing['$sp-10'],
    fontSize: theme.typography.pxToRem(16),
  },
  entityAutocompleteInput: {
    '& .MuiInput-root': {
      fontSize: `${theme.typography.pxToRem(16)}`
    },
  },
  'ul': {
    '.MuiTypography-root.MuiTypography-body1': {
      '& span': {
        fontSize: `${theme.typography.pxToRem(16)}`
      },
    }
  },
  textField: {
    width: '100%'
    
  },
  searchBox: {
    position: 'relative'
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  fullWidthFlex: {
    width: '100%'
  },
  actionMultiSelect:{
    '& .MuiFormControl-root': {
      marginTop: `0 !important`,
    }
  }
}));
